
    <button mat-button color="primary" title="Refresh" class="btn-refresh hide">
      <i class="fa-solid fa-arrows-rotate"></i>
    </button>
    <h3 class="cp-heading">
      <i class="fa-light fa-cloud"></i>Taking Calls or Chats?
    </h3>
    <section *ngIf="rootScope.ALISRegistrationCardMsgAfterSessionPopUp" class="error-wrapper">
      <f-alert variant="error">
        <p class="full-width">
          In order to fully restore the session you must re-register to ALIS Organization
        </p>
      </f-alert>
    </section>
    <section *ngIf="rootScope.ALISRegistrationCardError" class="error-wrapper">
      <f-alert variant="error">
        <p class="full-width">
          An unexpected error has occured. Try again later. If issue persists
          contact myIT.
        </p>
      </f-alert>
    </section>
    <section
      *ngIf="rootScope.ALISRegistrationCardSuccess"
      class="error-wrapper"
    >
      <f-alert
        variant="success"
        is-dismissable="true"
        (dismiss)="closeSuccess()"
      >
        <p>You are now registered to an ALIS organization.</p>
      </f-alert>
    </section>
    <!-- Below 3 sections are used to display Alerts for Training/Testing/EMEA -->
    <section *ngIf="rootScope.ALISTrainingTestingInfoMsg" class="error-wrapper">
      <f-alert variant="info">
        <p class="full-width">
          If <strong>Training/Testing</strong> is selected, you will not recieve calls or chats. Select <strong>Register</strong> to continue or select a different organization.
        </p>
      </f-alert>
    </section>
    <section *ngIf="rootScope.ALISChangeOrgInfoMsg" class="error-wrapper">
      <f-alert variant="info">
        <p class="full-width">
          You need to change the Organization in ALIS before you click on <strong>Register</strong>.
        </p>
      </f-alert>
    </section>
    <section *ngIf="rootScope.ALISTrainingTestingSuccessMsg" class="error-wrapper">
      <f-alert variant="success">
        <p class="full-width">
          Registration to <strong>Training/Testing</strong> complete. You will not receive calls or chats.
        </p>
      </f-alert>
    </section>
    <p>Before you get started, follow these steps:</p>
    <ul>
      <li>Step 1. Log in to connect to ALIS</li>
      <li>Step 2. Register with an ALIS organization</li>
    </ul>

    <form
      [formGroup]="ALISRegistration"
      (ngSubmit)="onSubmit()"
      style="width: 100%"
    >
      <mat-form-field appearance="fill" class="component-box">
        <mat-label>Select an organization</mat-label>
        <mat-select
          (selectionChange)="selectedRegionObj($event.value)"
          [(ngModel)]="prefrenceRegionObj"
          [compareWith]="compareFunction"
          disableRipple
          formControlName="region"
          name="region"
          disableOptionCentering
          [disabled]="this.disableOrgDropDown()"
        >
          <mat-option *ngFor="let region of regions" [value]="region">
            {{ region.displayName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- Button will get disabled if clicked on Register button after selecting Training/Testing option along with Change Organization button text. -->
      <f-button 
        class="full-width-btn hide"
        [text]="(rootScope.ALISRegistrationSuccessChangeOrg == true || rootScope.ALISTrainingTestingSuccessMsg == true) ? 'Change Organization' :  'Register'"
        type="submit"
        variant="progressive"
        [disabled]="ALISRegistration.invalid || disableRegisterButton"
      >
      </f-button>
      <!-- CCR6-1839 Enable to use below code for 2 buttons -->
  <div class="tba-button-controls">
    <f-button text="End Registration" [disabled]="this.enableDisableEndRegisterButton()" type="button" variant="action" (click)="this.endRegistration()">
    </f-button>
    <f-button text="Register" type="submit" [disabled]="this.enableDisableRegisterButton()" variant="progressive"></f-button>
  </div>
    </form>
    <app-loader
      *ngIf="alisRegionListLoader || rootScope.alisRegistrationLoader"
      [loaderType]="loaderType"
      [loaderMsg]="showLoaderMsg || rootScope.showAlisRegistrationLoaderMsg"
    ></app-loader>
  

